import { create } from 'zustand';
import { getTripKey } from '../../utils/tripAnalysis';
import { 
    sendAlerts,
    sendAlertsBatch,
    sendDeleteAlert
} from '../../channels/tripAlertsAnalysisChannel';

function hasAlertsData(payload) {
    return (
        'n1' in payload ||
        'n2' in payload ||
        'n3' in payload
    );
}

export const useTripAlertsAnalysisStore = create((set, get) => ({

    alertsMap: new Map(),

    getAlerts: (date, codigo) => {

        return get().alertsMap.get(
            getTripKey(date, codigo)
        ) || null;

    },

    setAlert: (payload, broadcast = true) => {

        if (
            !payload?.date ||
            !payload?.codigo
        ) {
            return;
        }

        if (!hasAlertsData(payload)) {
            return;
        }

        const alertsMap = new Map(
            get().alertsMap
        );

        alertsMap.set(
            getTripKey(payload.date, payload.codigo),
            payload
        );

        set({
            alertsMap
        });

        if (broadcast) {
            sendAlerts(payload);
        }

    },

    setAlertsBatch: (items = [], broadcast = true) => {

        if (items.length === 0) {
            return;
        }

        const alertsMap = new Map(
            get().alertsMap
        );

        for (const item of items) {

            if (
                !item?.date ||
                !item?.codigo
            ) {
                continue;
            }

            if (!hasAlertsData(item)) {
                continue;
            }

            alertsMap.set(
                getTripKey(item.date, item.codigo),
                item
            );

        }

        set({
            alertsMap
        });

        if (broadcast) {
            sendAlertsBatch(items);
        }

    },

    deleteAlert: (date, codigo, broadcast = true) => {

        const alertsMap = new Map(
            get().alertsMap
        );

        alertsMap.delete(
            getTripKey(date, codigo)
        );

        set({
            alertsMap
        });

        if(broadcast){
            sendDeleteAlert({date, codigo});
        }

    },

    exportAlerts: () => {

        return [
            ...get().alertsMap.values()
        ];

    },

    clearAlerts: () => {

        set({
            alertsMap: new Map()
        });

    }

}));